export const ExceptionConstants = {
  CODE: {
    CHANGE_TEMP_PASSWORD: 1002
  }
};
